module.exports = __webpack_public_path__ + "static/img/zt4_tab5.2200278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt4_tab5.jpg
// module id = 394S
// module chunks = 171